module.exports = __webpack_public_path__ + "static/media/Todolist.67d6e357.png";